import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, SunIcon, MoonIcon } from 'lucide-react';
interface NavigationProps {
  isDark: boolean;
  toggleTheme: () => void;
}
export function Navigation({
  isDark,
  toggleTheme
}: NavigationProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };
  const menuItems = [{
    label: 'Servicios',
    id: 'servicios'
  }, {
    label: 'Cotizador',
    id: 'cotizador'
  }, {
    label: 'Herramientas',
    id: 'herramientas'
  }, {
    label: 'Equipo',
    id: 'equipo'
  }, {
    label: 'Clientes',
    id: 'clientes'
  }, {
    label: 'Próximamente',
    id: 'proximamente'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 dark:bg-gray-900/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'}`} data-id="element-127">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-128">
        <div className="flex items-center justify-between h-20" data-id="element-129">
          {/* Logo */}
          <div className="flex-shrink-0" data-id="element-130">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uo4iwWVSECmyeiyJjvjjvp/K_V4-2.png" alt="KONTAXES" className="h-12 w-auto" data-id="element-131" />
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-1" data-id="element-132">
            {menuItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 hover:scale-105 text-gray-700 dark:text-gray-200 hover:bg-purple-100 dark:hover:bg-purple-900/30" data-id="element-133">
                {item.label}
              </button>)}

            {/* APP Button - Special styling */}
            <a href="https://app.kontaxes.com" target="_blank" rel="noopener noreferrer" className="ml-2 px-6 py-2 bg-gradient-to-r from-purple-600 to-purple-700 text-white font-bold rounded-lg hover:from-purple-700 hover:to-purple-800 transition-all duration-200 hover:scale-105 shadow-lg hover:shadow-xl" data-id="element-134">
              APP
            </a>

            {/* Theme Toggle - Fixed */}
            <button onClick={toggleTheme} className="ml-4 relative inline-flex h-8 w-14 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 bg-gray-300 dark:bg-purple-600" aria-label="Toggle theme" data-id="element-135">
              <span className="sr-only" data-id="element-136">Toggle theme</span>
              <span className={`inline-flex h-6 w-6 items-center justify-center transform rounded-full bg-white transition-transform ${isDark ? 'translate-x-7' : 'translate-x-1'}`} data-id="element-137">
                {isDark ? <MoonIcon size={14} className="text-purple-600" data-id="element-138" /> : <SunIcon size={14} className="text-yellow-500" data-id="element-139" />}
              </span>
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center space-x-2" data-id="element-140">
            <a href="https://app.kontaxes.com" target="_blank" rel="noopener noreferrer" className="px-4 py-2 bg-gradient-to-r from-purple-600 to-purple-700 text-white font-bold rounded-lg text-sm" data-id="element-141">
              APP
            </a>
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2 rounded-lg text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800" data-id="element-142">
              {isMobileMenuOpen ? <XIcon size={24} data-id="element-143" /> : <MenuIcon size={24} data-id="element-144" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800" data-id="element-145">
          <div className="px-4 py-4 space-y-2" data-id="element-146">
            {menuItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className="block w-full text-left px-4 py-2 rounded-lg text-sm font-medium text-gray-700 dark:text-gray-200 hover:bg-purple-100 dark:hover:bg-purple-900/30" data-id="element-147">
                {item.label}
              </button>)}
            <div className="pt-4 flex items-center justify-between" data-id="element-148">
              <span className="text-sm text-gray-600 dark:text-gray-400" data-id="element-149">
                Tema
              </span>
              <button onClick={toggleTheme} className="relative inline-flex h-8 w-14 items-center rounded-full transition-colors bg-gray-300 dark:bg-purple-600" data-id="element-150">
                <span className={`inline-flex h-6 w-6 items-center justify-center transform rounded-full bg-white transition-transform ${isDark ? 'translate-x-7' : 'translate-x-1'}`} data-id="element-151">
                  {isDark ? <MoonIcon size={14} className="text-purple-600" data-id="element-152" /> : <SunIcon size={14} className="text-yellow-500" data-id="element-153" />}
                </span>
              </button>
            </div>
          </div>
        </div>}
    </nav>;
}